import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import {
  TESTIMONIALS,
  getPublishableTestimonials,
  type Testimonial,
} from "@/data/testimonials";

interface TestimonialsProps {
  items?: Testimonial[];
}

/**
 * Prueba social real: solo reseñas con consentimiento y datos completos.
 * Si no queda ninguna, la sección desaparece en vez de caer a contenido
 * inventado. La tarjeta transcrita manda (legible); la captura real es
 * prueba secundaria opcional.
 */
export const Testimonials = ({ items = TESTIMONIALS }: TestimonialsProps) => {
  const testimonials = getPublishableTestimonials(items);
  if (testimonials.length === 0) return null;

  return (
    <section className="py-24 bg-[#F8F6F4]">
      <div className="container mx-auto px-6 sm:px-8 md:px-12 lg:px-16">
        <div className="text-center mb-16">
          <span className="text-primary font-medium tracking-wide uppercase text-sm">
            Lo Que Dicen Nuestros Clientes
          </span>
          <h2 className="font-playfair font-semibold text-4xl mt-2 text-brown-dark">
            Testimonios
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto mt-4 rounded-full"></div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((t) => (
            <figure
              key={t.id}
              className="bg-white rounded-2xl shadow-lg p-8 flex flex-col items-center hover:shadow-2xl transition-shadow duration-300"
            >
              <img
                src={t.image}
                alt={t.imageAlt}
                loading="lazy"
                className="w-16 h-16 rounded-full object-contain bg-primary/10 p-2 mb-4"
              />
              <figcaption className="text-center flex flex-col items-center flex-1">
                <h4 className="font-playfair font-semibold text-brown-dark text-lg mb-1">
                  {t.name}
                </h4>
                <p className="text-primary text-sm mb-4">{t.role}</p>
                <blockquote className="text-brown-light/90 italic">
                  “{t.quote}”
                </blockquote>
                {t.proofImage && (
                  <Dialog>
                    <DialogTrigger className="mt-5 text-sm font-medium text-primary-dark underline underline-offset-4 hover:text-brown">
                      Ver reseña real
                    </DialogTrigger>
                    <DialogContent className="max-w-sm p-2 bg-transparent border-0 shadow-none">
                      <DialogTitle className="sr-only">
                        Reseña de {t.name}
                      </DialogTitle>
                      <img
                        src={t.proofImage}
                        alt={t.proofAlt ?? `Captura de la reseña de ${t.name}`}
                        className="w-full h-auto max-h-[80vh] object-contain rounded-xl"
                      />
                    </DialogContent>
                  </Dialog>
                )}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
